import { render, staticRenderFns } from "./BtnAtualizarDocumento.vue?vue&type=template&id=6925b006"
import script from "./BtnAtualizarDocumento.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports